import React from 'react';
import { Table, message, Popconfirm, Button, Icon, Input, Select, Form, Modal, Row, Col,Tag,Badge,Tooltip} from 'antd';
import {AxiosServer} from 'axios'
import {SET,GET,DELETE, CREATE, UPDATE,RESTORE} from '../../../redux/actions/antdCompTestAction';
import {connect} from 'react-redux';
import ModalRender from './ModalRender';



function RenderBase({paras,get,create,set,del,update,restore}) {  

	//导入本组件所需参数变量
	const {data, dataLoading, dataFetchProps, selectedRows, selectedRowKeys, modalVisible, modalType, pwdModalVisible, selectedRow, selectedRowIndex} = paras;
	if (dataLoading){get(dataFetchProps)}

		
	const columns = [
	  {
		title: 'id',
		dataIndex: 'id',
		key: 'id',
		sorter: (a, b) => a.id - b.id,
		render: text => <a>{text}</a>,
	  },  {
		title: 'class_name',
		dataIndex: 'class_name',
		key: 'class_name',		
		sorter: (a, b) => a.class_name.length - b.class_name.length,		
		
	  },
	  {
		title: 'name',
		dataIndex: 'name',
		key: 'name',
		render:(text,record)=>(
			<div>
			{record.remarks ? <Tooltip placement="topLeft" title={record.remarks}><Tag color="#2E8B57">{text}</Tag> </Tooltip>
			  :text}
			</div>
		)
		
	  }, {
		title: 'code',
		dataIndex: 'code',
		key: 'code',		
		sorter: (a, b) => a.code.length - b.code.length,		
		
	  },
	  {
		title: 'value_string',
		dataIndex: 'value_string',
		key: 'value_string',
	  },{
		title: 'value_int',
		dataIndex: 'value_int',
		key: 'value_int',
	  },{
		title: 'value_json',
		dataIndex: 'value_json',
		key: 'json_value',
		render:text=>(
			  <div>
			  
			  {text?JSON.stringify(text):text}
			  
			  </div>
			)
	  },
	  {
		title: 'value_array',
		dataIndex: 'value_array',
		key: 'value_array',
		render:text=>(
			  <div>
			  
			  {text?text.map(tag => <Tag key ={tag} color='#2E8B57'>{tag}</Tag>):text}
			  
			  </div>
			)
		}];
	  
	  
	const rowSelection = {
		selectedRowKeys,
		selectedRows,
		onSelect: (record, selected, selectedRows, nativeEvent)=>{
			if(selected){set({selectedRowKeys: [record.id], selectedRow: record, selectedRows: [record]})
				} else {set({selectedRowKeys: [], selectedRow: {}, selectedRows: []})}
			},
		//onChange: (selectedRowKeys, selectedRows) => { SET({selectedRowKeys, selectedRows}) }
	};
	const BtnDelete =()=>{
		return del({id:selectedRow.id, selectedRowIndex}).then(res=>{
			message.info('id:' + selectedRow.id +' 的记录' + res)
			set({selectedRow:{}, selectedRowIndex: -1})
			});						
	}	 

	const BtnHandle=(e)=>{
		if (e.target.name ==='update'){
			set({modalVisible:true, modalType: 'update'}); 		  
		}	
		if (e.target.name ==='create'){
			set({modalVisible:true, modalType: 'create'}); 	  			
		}	
		
		if (e.target.name==='find'){
			return message.error('暂不支持')		  
		}
	} 	   

	const tabelDefinition = {
		rowKey: 'id',
		loading: dataLoading,
		size: 'normal',
		columns: columns,
		dataSource: data,
		//expandedRowRender: record => <p style={{ margin: 0}}>{JSON.stringify(record)}</p>,
		//rowSelection: rowSelection,
		onRow: (record, index) => { return { onClick: event => set({selectedRow:record, selectedRowIndex: index})}},
		rowClassName: (record, index) => index === selectedRowIndex ? 'selectedItem' : '',
	}

	const modalRenderProps = {

		item: modalType === 'create' ? {} : selectedRow,
		type: modalType,
		visible: modalVisible,
		onOk (data) {
			
		  set({modalVisible:false})
		  if (modalType === 'create') {
			  create(data).then(res=>{
					message.info(res);
			  })
		  } 

		  if (modalType === 'update') {
			 update(data, selectedRowIndex).then(res=> message.info(res));      
		  }
		},    
		onCancel () {
		  set({modalVisible:false})
		},
	}

	const ModalRenderGene = () => <ModalRender {...modalRenderProps}/>; 
	

	return (
	<div>
			<Row style={{ marginBottom: 10 }}>
			<Col span={20}><Input.Group compact size="large">
					  <Button onClick={BtnHandle} name='create'> <Icon type="plus" />添加</Button>
					  <Button onClick={BtnHandle} name='find' > <Icon type="search" />查找</Button>
					   <Button onClick={BtnHandle} name='update' disabled={selectedRowIndex===-1}> <Icon type="edit" />修改</Button>
						
							<Popconfirm title="Are you sure？" okText="Yes" cancelText="No" 
								 onConfirm ={BtnDelete} >				
									<Button disabled={selectedRowIndex===-1}> <Icon type="delete" /> 删除</Button>									
							</Popconfirm>					
				</Input.Group> 
				</Col>

			</Row>
		
	    <Table {...tabelDefinition}/>
	   {modalVisible&&<ModalRenderGene/>}
	   
	</div>)
	
}

const mapStateToProps = (state) => {
  return {
    paras: state.antdCompTestReducer
	}
}

const mapDispatchToProps = (dispatch,ownProps) => {
  return {  	
	set: (value)=>dispatch(SET(value)),
	get: (value)=>dispatch(GET(value)),
	del: (value)=>dispatch(DELETE(value)),
	create: (value)=>dispatch(CREATE(value)),
	update: (value)=>dispatch(UPDATE(value)),	
	restore: (value)=>dispatch(RESTORE(value)),
	}
}

const Parameter =connect(mapStateToProps,mapDispatchToProps)(RenderBase);

export default Parameter;
